import { useMemo } from 'react';
import { FindAllCompaniesResponse } from '@ansvar-sakerhet/api-client';

export const useContractors = (contractors: FindAllCompaniesResponse[]) => {
  const subcontractors = useMemo(() => contractors, [contractors]);

  return { subcontractors };
};
